import {
  CHANGE_STU_STATUS,
  SET_STUDENT,
  SET_STUDENTS,
  SET_STUDENT_DETAILS,
  TOGGLE_NAVBAR,
} from "../constants";
import * as api from "../../services/api";

const setStudents =
  (filter, page = 1) =>
  async (dispatch) => {
    try {
      const response = await api.filterStudentsByBadges(filter, page);

      dispatch({
        type: SET_STUDENTS,
        payload: response.data.data,
      });
    } catch (e) {
      // console.log(e);
    }
  };

const setStudent =
  (id, loggedIn = false) =>
  async (dispatch) => {
    try {
      let response;
      const getUserIdFromSearchQuery = window.location.search
        ?.split("=")[1]
        ?.split("&")[0];
      if (getUserIdFromSearchQuery) {
        response = await api.userById(getUserIdFromSearchQuery);
      }
      if (!getUserIdFromSearchQuery) {
        response = await api.getUserById(id || getUserIdFromSearchQuery);
      }
      if (response.data.data) {
        dispatch({
          type: SET_STUDENT,
          payload: response.data.data,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  };

export const clearStudent = () => async (dispatch) => {
  dispatch({
    type: SET_STUDENT,
    payload: null,
  });
};

const changeStudentStatus = (status) => async (dispatch) => {
  try {
    const response = await api.changeStudentStatus(status);

    if (response.data.data && response.status === 200) {
      dispatch({
        type: CHANGE_STU_STATUS,
        payload: response.data.data,
      });
    }
  } catch (error) {
    // console.log("ERR", error);
  }
};

export const navbarToggle = (boolean) => async (dispatch) => {
  dispatch({
    type: TOGGLE_NAVBAR,
    payload: boolean,
  });
};

export const setStudentProjectDetails = (details) => async (dispatch) => {
  dispatch({
    type: SET_STUDENT_DETAILS,
    payload: details,
  });
};

const actions = {
  setStudents,
  setStudent,
  changeStudentStatus,
};

export default actions;
